type Config = {
	width?: number
	height?: number
}

type IconProps = Config & {
	animate?: boolean
	className?: string
	paths?: Array<string | null>
}

const config: Config = {
	width: 30,
	height: 30,
}

export { config, type Config, type IconProps }

export { ArrowDown } from './ArrowDown'
export { ArrowLeft } from './ArrowLeft'
export { ArrowReturn } from './ArrowReturn'
export { ArrowReverse } from './ArrowReverse'
export { ArrowUp } from './ArrowUp'
export { Bell } from './Bell'
export { BellPlus } from './BellPlus'
export { Bio } from './Bio'
export { Compatibility } from './Compatibility'
export { CreditCard } from './CreditCard'
export { Gift } from './Gift'
export { Happy } from './Happy'
export { Home } from './Home'
export { Info_1 } from './Info_1'
export { Info_2 } from './Info_2'
export { Innovative } from './Innovative'
export { MapPin_1 } from './MapPin_1'
export { MapPin_2 } from './MapPin_2'
export { MapPin_3 } from './MapPin_3'
export { Message_1 } from './Message_1'
export { Message_2 } from './Message_2'
export { Message_3 } from './Message_3'
export { Message_4 } from './Message_4'
export { Message_5 } from './Message_5'
export { Minus } from './Minus'
export { Monitor_1 } from './Monitor_1'
export { Monitor_2 } from './Monitor_2'
export { Package } from './Package'
export { PackageOpen } from './PackageOpen'
export { Paragraph } from './Paragraph'
export { Phone } from './Phone'
export { Plus } from './Plus'
export { Product_1 } from './Product_1'
export { Product_2 } from './Product_2'
export { Product_3 } from './Product_3'
export { ProfileFemale } from './ProfileFemale'
export { ProfileMale } from './ProfileMale'
export { Recycling_1 } from './Recycling_1'
export { Recycling_2 } from './Recycling_2'
export { Search } from './Search'
export { SearchParagraph } from './SearchParagraph'
export { SearchStars } from './SearchStars'
export { Shop } from './Shop'
export { ShoppingBag_1 } from './ShoppingBag_1'
export { ShoppingBag_2 } from './ShoppingBag_2'
export { ShoppingBag_3 } from './ShoppingBag_3'
export { ShoppingCart } from './ShoppingCart'
export { Stars } from './Stars'
export { Together } from './Together'
export { Transport } from './Transport'
export { TransportFree } from './TransportFree'
export { Unhappy } from './Unhappy'
export { User_1 } from './User_1'
export { User_2 } from './User_2'
export { Vegan_1 } from './Vegan_1'
export { Vegan_2 } from './Vegan_2'
export { World_1 } from './World_1'
export { World_2 } from './World_2'
